import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

const KEY = 'agio-theme';

function isLight(): boolean {
  return document.body.classList.contains('theme-light');
}

/** Light/dark toggle for the customer-facing portal. Applies a class to
 * <body> rather than routing through React state/context — every color in
 * the app already reads its CSS custom properties from there (same mechanism
 * `.light-scope` uses for the admin area), so no component needs to know the
 * toggle exists. The class is also set synchronously in index.html before
 * React mounts, so there's no flash of the wrong theme on load. */
export function ThemeToggle() {
  const [light, setLight] = useState(isLight);

  useEffect(() => {
    document.body.classList.toggle('theme-light', light);
    try {
      localStorage.setItem(KEY, light ? 'light' : 'dark');
    } catch {
      // Private browsing / storage disabled — theme just won't persist.
    }
  }, [light]);

  return (
    <button
      type="button"
      onClick={() => setLight((v) => !v)}
      title={light ? 'עבור לתצוגה כהה' : 'עבור לתצוגה בהירה'}
      aria-label={light ? 'עבור לתצוגה כהה' : 'עבור לתצוגה בהירה'}
      className="flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground transition-colors hover:bg-muted"
    >
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
